import { appInsights } from './appInsights.service';

export enum ErrorSeverity {
    Verbose = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}

export class ErrorLogger {
    private static instance: ErrorLogger;

    static get(): ErrorLogger {
        if (!ErrorLogger.instance) {
            ErrorLogger.instance = new ErrorLogger();
        }
        return ErrorLogger.instance;
    }

    logError(
        error: unknown,
        context: {
            component?: string;
            action?: string;
            severity?: ErrorSeverity;
            additionalData?: Record<string, any>;
        } = {}
    ): void {
        const severity = context.severity ?? ErrorSeverity.Error;
        const exception = error instanceof Error ? error : new Error(String(error));

        appInsights.trackException({
            exception,
            properties: {
                component: context.component,
                action: context.action,
                ...context.additionalData
            },
            severityLevel: severity
        });
    }
}
